<template>
  <div class="reviews-page">
    <div v-if="screenWidth >= 768" class="reviews-page-tablet">
      <ReviewsPageItem v-for="(item, i) in data.items" :result="item" :key="i"/>
      <div class="reviews-page-more" v-if="data.pagen?.moreLink">
        <span></span>
        <button class="reviews-page-more-button" @click.prevent="showMore">{{ data.messages.showMore }}</button>
      </div>
    </div>
    <template v-else>
      <ReviewsPageMobile :result="data.items"/>
    </template>
  </div>
</template>

<script>
import {ref} from "vue";
import {send} from "../../../services/api";
import {useAProgressBar, useAModal} from '~/components/ui';
import ReviewsPageMobile from "./ReviewsPageMobile/ReviewsPageMobile.vue";

export default {
  name: 'ReviewsPage',
  components: {ReviewsPageMobile},
  props: ['result'],
  setup: (props, ctx) => {
    const data = ref(props.result);
    const progress = useAProgressBar();
    const showMore = async () => {
      progress.show();
      await send(data.value.pagen.moreLink, {method: "GET"}, {}).then((response) => {
        for (let index in response[data.value.responseKey].items) {
          if (response[data.value.responseKey].items[index].name != undefined && response[data.value.responseKey].items[index].name) {
            data.value.items.push(response[data.value.responseKey].items[index]);
          }
        }
        data.value.pagen = response[data.value.responseKey].pagen;
        progress.hide();
      });
    };
    return {
      data,
      showMore
    }
  },
  mounted() {
    const showModal = () => {
      const modal = useAModal();
      let hash = window.location.hash.replace('#','');
      if(hash=='addReviewPopUp') {
        modal.show('reviews-page-modal');
      }
    };
    showModal();
    window.addEventListener('hashchange', function () {
      showModal();
    });
  }

}
</script>

<style lang="scss" scoped>
.reviews-page {
  padding: 72px 0 129px;
  @include tablet{
    padding: 70px 0 60px;
  }
}
.reviews-page-tablet{
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 30px;
}
.reviews-page-more{
  display: grid;
  grid-template-columns: 130px minmax(0, 803px);
  grid-column-gap: 108px;
  @include tablet{
    grid-column-gap: 29px;
  }
}
.reviews-page-more-button{
  border: 1px solid #D8DCDE;
  border-radius: 6px;
  background-color: transparent;
  cursor: pointer;
  height: 50px;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
}
</style>